/* EVParto My Garage.
   Storage is deliberately dumb and inspectable: one localStorage key holding an
   array of plain objects. No framework, no build step, no dependency, and the
   exact shape that will later be written to a customer metafield so that moving
   to account-backed storage changes where it is saved and nothing else.

   Every read is wrapped: localStorage throws outright in some privacy modes and
   in embedded previews, and a garage that takes the page down with it is worse
   than no garage. */
(function () {
  var KEY = 'evp_garage';

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 12))); } catch (e) {}
    document.dispatchEvent(new CustomEvent('evp:garage', { detail: { list: list } }));
  }
  function label(v) {
    return [v.brand, v.model, v.years].filter(Boolean).join(' ');
  }

  window.EVPGarage = {
    all: read,
    add: function (v) { var l = read(); l.unshift(v); write(l); return l; },
    remove: function (i) { var l = read(); l.splice(i, 1); write(l); return l; },
    label: label
  };

  /* The header chip: silent until there is something to show. */
  function paintChip() {
    var chip = document.querySelector('[data-garage-chip]');
    if (!chip) return;
    var list = read();
    if (!list.length) { chip.hidden = true; return; }
    chip.hidden = false;
    var lbl = chip.querySelector('[data-garage-chip-label]');
    if (lbl) lbl.textContent = list.length === 1 ? label(list[0]) : list.length + ' vehicles';
    chip.onclick = function () { window.location = '/pages/my-garage'; };
  }

  function paintPanel() {
    var panel = document.querySelector('[data-garage-panel]');
    if (!panel) return;
    var list = read();
    var box = panel.querySelector('[data-garage-list]');
    var empty = panel.querySelector('[data-garage-empty]');
    if (!box) return;
    box.innerHTML = '';
    empty.hidden = list.length > 0;
    list.forEach(function (v, i) {
      var row = document.createElement('div');
      row.className = 'gar__item';
      row.innerHTML =
        '<div class="gar__itemtxt"><b></b><span></span></div>' +
        '<div class="gar__itemgo">' +
        '<a class="gar__find" href="/search?q=' + encodeURIComponent([v.brand, v.model].filter(Boolean).join(' ')) + '">Find parts</a>' +
        '<button class="gar__rm" type="button" aria-label="Remove vehicle">Remove</button></div>';
      row.querySelector('b').textContent = label(v);
      row.querySelector('span').textContent = v.code ? 'Type code ' + v.code : 'No type code saved';
      row.querySelector('.gar__rm').onclick = function () { window.EVPGarage.remove(i); };
      box.appendChild(row);
    });
  }

  function wireForm() {
    var panel = document.querySelector('[data-garage-panel]');
    if (!panel) return;
    var form = panel.querySelector('[data-garage-form]');
    if (!form) return;
    panel.querySelectorAll('[data-garage-add]').forEach(function (b) {
      b.onclick = function () { form.hidden = false; form.querySelector('select,input').focus(); };
    });
    var cancel = panel.querySelector('[data-garage-cancel]');
    /* form.reset() puts the selects back to their first option but leaves the
       OPTIONS this file wrote in place, so a reopened form would offer BYD's
       models under a blank make. Rewiring rebuilds them from the tree. */
    if (cancel) cancel.onclick = function () {
      form.hidden = true; form.reset();
      var c = document.querySelector('[data-garage-count]'); if (c) c.hidden = true;
      wireCascade();
      var b = form.querySelector('[data-gar-brand]');
      if (b) { b.dispatchEvent(new Event('change')); }
    };
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = {};
      ['brand', 'model', 'years', 'code'].forEach(function (k) {
        v[k] = String((form.elements[k] && form.elements[k].value) || '').trim().slice(0, 40);
      });
      if (!v.brand || !v.model) return;
      window.EVPGarage.add(v);
      form.reset(); form.hidden = true;
      var c2 = document.querySelector('[data-garage-count]'); if (c2) c2.hidden = true;
      var b2 = form.querySelector('[data-gar-brand]');
      if (b2) { b2.dispatchEvent(new Event('change')); }
    });
  }


  /* ------------------------------------------------------------------ *
   * THE CASCADE.  06-09.
   *
   * Brand narrows model, model narrows year, year narrows type code, and
   * every option comes from shop.metafields.evp.vehicles, which rig_garage
   * builds out of evparto_core.fitment. The picker therefore cannot produce
   * a vehicle the catalogue does not hold. The old form was three free-text
   * boxes, so `Atto3` and `ATTO 3` both saved fine and then matched nothing
   * for the rest of that browser's life.
   *
   * Tree shape:  {brands:[{b, models:[{m, n, p, y:[{y, c:[code]}]}]}]}
   *   n = parts we hold for the model, p = of those, priced and sellable.
   *
   * A level is DISABLED until the one above it is answered, and it is
   * disabled in the Liquid as well, so the form is never briefly answerable
   * in the wrong order while this file is still downloading.
   * ------------------------------------------------------------------ */
  function wireCascade() {
    var host = document.querySelector('[data-garage-cascade]');
    var src  = document.querySelector('[data-garage-tree]');
    if (!host || !src) return;               /* the typed fallback is rendered */

    var tree;
    try { tree = JSON.parse(src.textContent || '{}'); } catch (e) { return; }
    if (!tree || !tree.brands || !tree.brands.length) return;

    var selB = host.querySelector('[data-gar-brand]');
    var selM = host.querySelector('[data-gar-model]');
    var selY = host.querySelector('[data-gar-year]');
    var selC = host.querySelector('[data-gar-code]');
    var note = document.querySelector('[data-garage-count]');
    if (!selB || !selM || !selY || !selC) return;

    function fill(sel, placeholder, items, valueOf, labelOf) {
      sel.innerHTML = '';
      var o = document.createElement('option');
      o.value = ''; o.textContent = placeholder;
      sel.appendChild(o);
      items.forEach(function (it) {
        var e = document.createElement('option');
        e.value = valueOf(it);
        e.textContent = labelOf(it);
        sel.appendChild(e);
      });
      sel.disabled = items.length === 0;
    }

    function brand() {
      for (var i = 0; i < tree.brands.length; i++) {
        if (tree.brands[i].b === selB.value) return tree.brands[i];
      }
      return null;
    }
    function model() {
      var b = brand();
      if (!b) return null;
      for (var i = 0; i < b.models.length; i++) {
        if (b.models[i].m === selM.value) return b.models[i];
      }
      return null;
    }
    function year() {
      var m = model();
      if (!m) return null;
      for (var i = 0; i < m.y.length; i++) {
        if (String(m.y[i].y) === String(selY.value)) return m.y[i];
      }
      return null;
    }

    /* The count is shown while the buyer is still choosing, not three pages
       later. A model we hold four priced parts for should say so here. */
    function paintCount() {
      if (!note) return;
      var m = model();
      if (!m) { note.hidden = true; note.textContent = ''; return; }
      note.hidden = false;
      note.className = 'gar__count' + (m.p === 0 ? ' gar__count--none' : '');
      if (m.p > 0) {
        note.textContent = m.p + (m.p === 1 ? ' part' : ' parts') +
          ' priced and ready to ship for this model' +
          (m.n > m.p ? ', and ' + (m.n - m.p) + ' more on the quote route.' : '.');
      } else {
        note.textContent = 'We hold ' + m.n + (m.n === 1 ? ' part' : ' parts') +
          ' for this model, none of them priced online yet. Save it anyway and ' +
          'ask us for a quote, or check back as the catalogue is priced.';
      }
    }

    function resetFrom(level) {
      if (level <= 2) { fill(selM, 'Choose a make first', [], String, String); selM.disabled = true; }
      if (level <= 3) { fill(selY, 'Choose a model first', [], String, String); selY.disabled = true; }
      if (level <= 4) { fill(selC, 'Choose a year first', [], String, String); selC.disabled = true; }
      if (level <= 2 && note) { note.hidden = true; }
    }

    selB.addEventListener('change', function () {
      resetFrom(2);
      var b = brand();
      if (!b) return;
      fill(selM, 'Choose a model', b.models,
           function (m) { return m.m; },
           function (m) { return m.m + (m.p ? '  (' + m.p + ' priced)' : ''); });
    });

    selM.addEventListener('change', function () {
      resetFrom(3);
      paintCount();
      var m = model();
      if (!m) return;
      /* A year of 0 is a row the EPC gave no year for. It is a real vehicle and
         is offered as such rather than dropped, which would hide whole models. */
      fill(selY, 'Any year', m.y,
           function (y) { return String(y.y || ''); },
           function (y) { return y.y ? String(y.y) : 'Year not stated'; });
    });

    selY.addEventListener('change', function () {
      resetFrom(4);
      var y = year();
      if (!y || !y.c || !y.c.length) {
        fill(selC, 'No type codes recorded for this year', [], String, String);
        selC.disabled = true;
        return;
      }
      fill(selC, 'All variants', y.c, String, String);
    });
  }

  function paint() { paintChip(); paintPanel(); }
  document.addEventListener('evp:garage', paint);
  function boot() { paint(); wireForm(); wireCascade(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
